import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import {
  switchLanguage,
  intializeProductResults,
  setNoFrenchContent,
} from "actions-lib"
import LanguageDropdown from "./LanguageDropdown"

export const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(
    {
      switchLanguage,
      intializeProductResults,
      setNoFrenchContent,
    },
    dispatch,
  ),
})

export const mapStateToProps = (state) => ({
  siteLanguage: state.siteLanguage,
  noFrenchContent: state.customerSelections?.noFrenchContent,
})

export default connect(mapStateToProps, mapDispatchToProps)(LanguageDropdown)
